import { render, staticRenderFns } from "./ManagePrivileges.vue?vue&type=template&id=fe08ee46"
import script from "./ManagePrivileges.vue?vue&type=script&lang=js"
export * from "./ManagePrivileges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports